import React, { useContext } from "react";
import Grid from '@mui/material/Grid2';
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import OverviewCard from "../components/Card/OverviewCard";
import { participantSortFn } from "../components/const";

const Overview = () => {
  const context = useContext(RoomsRealtimeContext);
  const meeting = { ...context.detail?.meeting };

  return (
    <Grid
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        maxHeight: "100%",
        maxWidth: "100%",
        overflowY: "scroll",
        overflowX: "hidden",

        "& > *": {
          margin: 1,
        },

        paddingBottom: 2
      }}>
      {meeting.participants
        ?.filter(({ device }) => device?.id !== undefined)
        .sort(participantSortFn)
        .map((part) => (
          <OverviewCard key={part?.device?.id} participant={part} />
        ))}
    </Grid>
  );
};

export default Overview;
